// import AutoScrollAmenities from "./components/AutoScrollAmenities";
// import ContactForm from "./components/ContactForm";
// import FloatingActions from "./components/FloatingActions";
// import HeroSection from "./components/HeroSection";
// import { LanguageProvider } from "./components/LanguageContext";
// import LocationSection from "./components/LocationSection";
// import LuxuryInfoSection from "./components/LuxuryInfoSection";
// import Navbar from "./components/Navbar";
// import VideoFullViewportSection from "./components/VideoFullViewportSection";
// import LocationMap from "./LocationMap";


// function App() {
//   return (
//     <div className="App">
//           <LanguageProvider>
//      <Navbar />
//       <HeroSection />
//       <FloatingActions/>
//                   <LuxuryInfoSection/>
//       <AutoScrollAmenities/>
//       <VideoFullViewportSection/>
//       <LocationSection/>
//       <ContactForm/>
//               {/* <LocationMap /> */}
//                         </LanguageProvider>

      
//     </div>
//   );
// }

// export default App;





// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import AutoScrollAmenities from "./components/AutoScrollAmenities";
// import ContactForm from "./components/ContactForm";
// import FloatingActions from "./components/FloatingActions";
// import HeroSection from "./components/HeroSection";
// import { LanguageProvider } from "./components/LanguageContext";
// import LocationSection from "./components/LocationSection";
// import LuxuryInfoSection from "./components/LuxuryInfoSection";
// import Navbar from "./components/Navbar";
// import VideoFullViewportSection from "./components/VideoFullViewportSection";
// import { usePageTitle } from "./components/usePageTitle";
// import { EmaarHeroSection } from "./components/Emaar/EmaarHeroSection";
// import { EmaarDepartment } from "./components/Emaar/EmaarDepartment";
// import { EmaarHallPresenter } from "./components/Emaar/EmaarHallPresenter";
// import { EmaarwasaelElraha } from "./components/Emaar/EmaarwasaelElraha";
// import { Locationimage } from "./components/Emaar/Locationimage";
// import { EmaarContactForm } from "./components/Emaar/EmaarContactForm";
// import { EmaarFloatingButtons } from "./components/Emaar/EmaarFloatingButtons";
// import { EmaarNavbar } from "./components/Emaar/EmaarNavbar";
// import { ContactusButton } from "./components/ContactusButton";

// const MasarPage = () => {
//   usePageTitle(); // ← هنا بس
//   return (
//     <LanguageProvider>
//       <Navbar />
//       <HeroSection />
//       <FloatingActions />
//       <LuxuryInfoSection />
//       <ContactusButton/>
//       <AutoScrollAmenities />
//       <VideoFullViewportSection />
//             <ContactusButton/>

//       <LocationSection />
//       <ContactForm />
//     </LanguageProvider>
//   );
// };

// const EmaarPage = () => {
//   usePageTitle(); // ← وهنا
//   return (
//     <LanguageProvider>
//       <EmaarNavbar/>
//       <EmaarHeroSection />
//       <EmaarDepartment/>
//       <EmaarHallPresenter/>
//       <EmaarwasaelElraha/>
//       <Locationimage/>
//       <EmaarContactForm/>
//       <EmaarFloatingButtons/>
//     </LanguageProvider>
//   );
// };

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/masar" element={<MasarPage />} />
//         <Route path="/emaar" element={<EmaarPage />} />
//         {/* redirect الـ root لـ masar لو عايز */}
//         <Route path="/" element={<MasarPage />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;





















import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AutoScrollAmenities from "./components/AutoScrollAmenities";
import ContactForm from "./components/ContactForm";
import FloatingActions from "./components/FloatingActions";
import HeroSection from "./components/HeroSection";
import { LanguageProvider } from "./components/LanguageContext";
import LocationSection from "./components/LocationSection";
import LuxuryInfoSection from "./components/LuxuryInfoSection";
import Navbar from "./components/Navbar";
import VideoFullViewportSection from "./components/VideoFullViewportSection";
import { EmaarHeroSection } from "./components/Emaar/EmaarHeroSection";
import { EmaarDepartment } from "./components/Emaar/EmaarDepartment";
import { EmaarHallPresenter } from "./components/Emaar/EmaarHallPresenter";
import { EmaarwasaelElraha } from "./components/Emaar/EmaarwasaelElraha";
import { Locationimage } from "./components/Emaar/Locationimage";
import { EmaarContactForm } from "./components/Emaar/EmaarContactForm";
import { EmaarFloatingButtons } from "./components/Emaar/EmaarFloatingButtons";
import { EmaarNavbar } from "./components/Emaar/EmaarNavbar";
import { ContactusButton } from "./components/ContactusButton";
import SEO from "./components/SEO";
import { RegisterButton } from "./components/Emaar/RegisterButton";

// ── SEO content لكل صفحة ──
// TODO: راجع الوصف/العنوان بتاع Emaar وحطّ صورة OG حقيقية للاتنين
const SEO_CONTENT = {
  masar: {
    path: "/masar",
    title: {
      ar: "Masar | فلل فاخرة في الشارقة",
      en: "Masar | Luxury Villas in Sharjah",
    },
    description: {
      ar: "فلل من 2 إلى 5 غرف نوم في مسار - الشارقة، بخطط سداد مرنة. احجز وحدتك الآن - عدد الوحدات محدود.",
      en: "2 to 5 bedroom villas at Masar, Sharjah, with flexible payment plans. Book your unit now — limited availability.",
    },
    image: "https://homewalkers.ae/masar-og.jpg",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: "Masar",
      url: "https://homewalkers.ae/masar",
      logo: "https://homewalkers.ae/logo.svg",
      description: "فلل فاخرة في الشارقة بخطط سداد مرنة.",
      address: { "@type": "PostalAddress", addressLocality: "Sharjah", addressCountry: "UAE" },
    },
  },
  emaar: {
    path: "/emaar",
    // TODO: دي عناوين ووصف مبدئي بس - محتاج التفاصيل الحقيقية بتاعة مشروع Emaar عشان أظبطها صح
    title: {
      ar: "Emaar | عقارات فاخرة",
      en: "Emaar | Premium Real Estate",
    },
    description: {
      ar: "اكتشف مشروع Emaar، وحدات سكنية فاخرة بموقع مميز وخطط سداد مرنة.",
      en: "Discover the Emaar project — premium residential units in a prime location with flexible payment plans.",
    },
    image: "https://homewalkers.ae/emaar-og.jpg",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: "Emaar",
      url: "https://homewalkers.ae/emaar",
      logo: "https://homewalkers.ae/logo.svg",
      description: "وحدات سكنية فاخرة بخطط سداد مرنة.",
      address: { "@type": "PostalAddress", addressLocality: "Sharjah", addressCountry: "UAE" },
    },
  },
};

const MasarPage = () => {
  return (
    <LanguageProvider>
      <SEO {...SEO_CONTENT.masar} />
      <Navbar />
      <HeroSection />
      <FloatingActions />
      <LuxuryInfoSection />
      <ContactusButton />
      <AutoScrollAmenities />
      <VideoFullViewportSection />
      <ContactusButton />
      <LocationSection />
      <ContactForm />
    </LanguageProvider>
  );
};

const EmaarPage = () => {
  return (
    <LanguageProvider>
      <SEO {...SEO_CONTENT.emaar} />
      <EmaarNavbar />
      <EmaarHeroSection />
      <EmaarDepartment />
                  <RegisterButton/>

      <EmaarHallPresenter />
      <RegisterButton/>
      <EmaarwasaelElraha />
            <RegisterButton/>

      <Locationimage />
      <EmaarContactForm />
      <EmaarFloatingButtons />
    </LanguageProvider>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/masar" element={<MasarPage />} />
          <Route path="/emaar" element={<EmaarPage />} />
          {/* redirect الـ root لـ masar لو عايز */}
          <Route path="/" element={<MasarPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
